import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectToken } from '../utility/Redux/security';
import {
  selectPrefix,
  selectTableMasterPrefix,
  selectWidth,
} from '../utility/Redux/profile';
import { useState } from 'react';

import axios from 'axios';
import { useEffect } from 'react';
import { useFocus } from '../utility/hooks/hooks';
import {
  setAlertWithTitle,
  setSessionExpired,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import GeniustextInput from '../utility/component/mastertext';
import {
  ModifyButton,
  SaveButton,
  UndoButton,
} from '../utility/component/SNAA_buttons';
import GeniusDatagrid from '../utility/component/datagrid.js/geniusDatagrid';
import { useNavigate } from 'react-router-dom';
import { toProperCase } from '../utility/component/format';
import { CallAPIPromise } from '../utility/func/func';
import { CategoryOutlined, Close, FormatListBulletedRounded } from '@mui/icons-material';
import './sectionMaster.css';

const GeniusSectionMaster = () => {
  const dispatch = useDispatch();
  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);
  const windowWidth = useSelector(selectWidth);
  const [id, setId] = useState();
  const [secName, setSecName] = useState();
  const [rows, setRows] = useState([]);
  const [secError, setSecError] = useFocus();

  const columns = [
    {
      field: 'SECTION_NAME',
      type: 'string',
      renderHeader: (params) => <div>Section Name</div>,
      width: windowWidth > 764 ? 400 : 300,
      headerAlign: 'center',
      align: 'left',
      renderCell: (params) => {
        const runningCaseValue = params.value;
        return <div>{runningCaseValue}</div>;
      },
    },
  ];
  const masterPrefix = useSelector(selectTableMasterPrefix);

  const getData = async () => {
    // dispatch(setSpinnerLoading('Loading'));
    dispatch(setSpinnerLoading('Loading'));
    CallAPIPromise('/api/masters/listSectionMaster', {
      table_prefix_master: masterPrefix,
      SECTION_NAME: '',
    })
      .then((p) => {
        setRows(p.data.response);
      })
      .catch((error) => {
        console.log(error.response.data.name);
        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
          console.log(error.response);
        }
      })
      .finally(() => {
        setSecError();
        dispatch(setSpinnerLoading(false));
      });
  };

  useEffect(() => {
    getData();
  }, []);
  const saveSectionMasterApi = () => {
    if (secName) {
      const isDuplicateMobile = rows.some(
        (row) => row.SECTION_NAME === secName
      );

      if (isDuplicateMobile) {
        dispatch(
          setAlertWithTitle({
            title: 'Information Error!',
            msg: 'This Section is already exists. Please choose a different section.',
          })
        );
        return;
      }

      const data = {
        table_prefix_master: masterPrefix,
        CODE: id ? id : '',
        SECTION_NAME: secName,
      };

      id
        ? dispatch(setSpinnerLoading('Updating'))
        : dispatch(setSpinnerLoading('Saving'));
      CallAPIPromise(`/api/masters/saveSectionMaster`, data)
        .then(async function (response) {
          if (!response.data.error) {
            id
              ? dispatch(
                  setAlertWithTitle({
                    title: 'Success.',
                    msg: 'Data Updated successfully.',
                    lottie: 'success',
                  })
                )
              : dispatch(
                  setAlertWithTitle({
                    title: 'Success.',
                    msg: 'Data Saved successfully.',
                    lottie: 'success',
                  })
                );
          } else {
            dispatch(
              setAlertWithTitle({
                title: 'Error 112',
                msg: response.data.error,
              })
            );
            console.log(!response.data.error);
          }
        })
        .catch(function (error) {
          if (error.response.data.name === 'TokenExpiredError') {
            dispatch(setSessionExpired(true));
            console.log(error.response);
          }
          console.log(error);
          dispatch(
            setAlertWithTitle({
              title: 'ERROR',
              msg: 'Something went wrong.',
              lottie: 'reject',
            })
          );
        })
        .finally(() => {
          dispatch(setSpinnerLoading(false));
          setSecName('');
          setId('');
          getData();
        });
    } else {
      if (!secName) {
        dispatch(
          setAlertWithTitle({
            title: 'ERROR',
            msg: 'Please Enter Section Name.',
            lottie: 'reject',
          })
        );
        setSecError();
      }
    }
  };
  const navigate = useNavigate();
  return (
    <main className="section-master-page">
      <div className="section-master-shell">
        <header className="section-master-hero">
          <div className="section-master-hero__glow" />
          <div className="section-master-hero__content">
            <span className="section-master-hero__icon"><CategoryOutlined /></span>
            <div><span className="section-master-eyebrow">Inventory setup</span><h1>Section Master</h1><p>Organise your items into clear, easy-to-manage sections.</p></div>
          </div>
          <button type="button" className="section-master-back" onClick={() => navigate('/masters')} aria-label="Back to Masters" title="Back to Masters"><Close fontSize="small" /></button>
        </header>

        <section className="section-master-card section-master-entry">
          <div className="section-master-card__heading">
            <div><span className="section-master-card__eyebrow">Section details</span><h2>{id ? 'Update section' : 'Create a section'}</h2></div>
            <span className="section-master-card__status">{id ? 'Editing selected section' : 'New section'}</span>
          </div>
          <div id="input" className="section-master-entry__body">
            <div className="section-master-input">
            <GeniustextInput
              title={'Section Name'}
              width={windowWidth > 764 ? '400px' : '300px'}
              type={'text'}
              //   search={handleOpenDeptHelp}
              value={secName}
              onChange={(e) => {
                setSecName(toProperCase(e.target.value));
              }}
              refrance={secError}
            />
            </div>
            <div className="section-master-actions">
              {id ? (
                <ModifyButton onClick={saveSectionMasterApi} />
              ) : (
                <SaveButton onClick={saveSectionMasterApi} />
              )}

              <UndoButton
                onClick={() => {
                  setSecName('');
                  setId('');
                }}
              />
            </div>
          </div>
        </section>

        <section className="section-master-card section-master-table-card">
          <div className="section-master-card__heading">
            <div><span className="section-master-card__eyebrow">Saved sections</span><h2>Your section catalogue</h2></div>
            <span className="section-master-table-count"><FormatListBulletedRounded fontSize="small" /> {rows.length} sections</span>
          </div>
          <div className="section-master-table-wrap">
          <div
            className="section-master-grid"
          >
            <GeniusDatagrid
              rowID={(e) => e.CODE}
              onRowClick={(p) => {
                setId(p.row.CODE);
                setSecName(p.row.SECTION_NAME);
              }}
              columns={columns}
              list={rows}
            />
          </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default GeniusSectionMaster;
